module.exports = __webpack_public_path__ + "Ubisoft-plus-cloud-gaming-devices_desktop.webp";